import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  queue: [], // This will store an array of message objects
  currentMessage: null, // This will store the message currently being displayed
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    showMessage: (state, action) => {
      // Create a message object with default properties.
      const newMessage = {
        message: action.payload.message,
        autoHideDuration: action.payload.autoHideDuration || 2000,
        anchorOrigin: action.payload.anchorOrigin || {
          vertical: 'top',
          horizontal: 'center',
        },
        variant: action.payload.variant || '',
        // Optionally add the loading property if it was passed.
        ...(action.payload.loading !== undefined ? { loading: action.payload.loading } : {}),
      };
      // Enqueue the new message
      state.queue.push(newMessage);
      // If there is no current message, dequeue the first message to display
      if (!state.currentMessage) {
        state.currentMessage = state.queue.shift();
      }
    },
    hideMessage: (state) => {
      // When a message is hidden, check if there are more messages in the queue
      if (state.queue.length > 0) {
        // Dequeue the next message to display
        state.currentMessage = state.queue.shift();
      } else {
        // If no more messages, clear the current message
        state.currentMessage = null;
      }
    },
  },
});

export const { showMessage, hideMessage } = messageSlice.actions;
export const selectMessage = (state) => state.message.currentMessage;
export const isMessageOpen = (state) => !!state.message.currentMessage;

export default messageSlice.reducer;
